// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"22":"ff627653","29":"b9018bb6","191":"dd533fbd","205":"cf856384","274":"99a79175","442":"c7bf4634","472":"1febeb2f","529":"86fac30e","622":"41ba30df","696":"4be7f952","718":"8b425a6d","852":"c737bdb8","878":"70005308"}[chunkId] + ".chunk.js";
};